//assets
import {
  IconOpportunity,
  IconGameChangers,
  IconFunding,
} from '@loadsmart/icons';

import { FeatureGroup, responsiveIconStyle } from '@/components/Feature';
import { Container } from '@/components/Grid/Container';

import {
  Featured,
  ReasonListTitle,
  FeatureHighlight,
  FeaturedTitle,
  FeaturedDescription,
  FeaturedIcon,
  FeaturedSection,
} from './WeInNumbers.styles';

const DEFAULT_CONTENT = {
  title: 'Here’s why you',
  titleLine2: 'should care',
  features: {
    game_changers: {
      value: '400+',
      titleLine1: 'GAME',
      titleLine2: 'CHANGERS',
      description:
        'Our diverse and global team is a rapidly growing group who collaborate to create cutting edge, user-friendly technology services in the logistics industry and we have fun while doing it.',
    },
    industry_opportunity: {
      value: '$900B+',
      title: 'INDUSTRY OPPORTUNITY',
      description:
        'It’s not often you’re faced with a $900B+ industry that hasn’t embraced technology. With this type of market cap, disruption is inevitable, and we’re leading the way.',
    },
    series_d_funding: {
      value: '$200M',
      titleLine1: 'SERIES ‘D’',
      titleLine2: 'FUNDING',
      description:
        'We’ve raised $346.4M to date from some of the industry’s biggest names and strategic partners, including BlackRock, SoftBank Latin America Fund , TFI International, Maersk, Ports America, and CSX Corp.',
    },
  },
};

const COMPACT_VALUE_LENGTH = 24;

export const WeInNumbers = ({ content = DEFAULT_CONTENT }) => {
  // All three values switch together so the columns stay visually consistent.
  const highlightClass = Object.values(content.features).some(
    (feature) => feature.value.length > COMPACT_VALUE_LENGTH
  )
    ? 'compact'
    : '';

  return (
    <FeaturedSection>
      <Container>
        <ReasonListTitle>
          {content.title}
          <br /> {content.titleLine2}
        </ReasonListTitle>
        <FeatureGroup>
          <Featured>
            <FeaturedIcon>
              <IconGameChangers role="img" css={responsiveIconStyle} />
            </FeaturedIcon>
            <FeatureHighlight className={highlightClass}>
              {content.features.game_changers.value}
            </FeatureHighlight>
            <FeaturedTitle>
              {content.features.game_changers.titleLine1}
              <br /> {content.features.game_changers.titleLine2}
            </FeaturedTitle>
            <FeaturedDescription>
              {content.features.game_changers.description}
            </FeaturedDescription>
          </Featured>
          <Featured>
            <FeaturedIcon>
              <IconOpportunity role="img" css={responsiveIconStyle} />
            </FeaturedIcon>
            <FeatureHighlight className={highlightClass}>
              {content.features.industry_opportunity.value}
            </FeatureHighlight>
            <FeaturedTitle>
              {content.features.industry_opportunity.title}
            </FeaturedTitle>
            <FeaturedDescription>
              {content.features.industry_opportunity.description}
            </FeaturedDescription>
          </Featured>
          <Featured>
            <FeaturedIcon>
              <IconFunding role="img" css={responsiveIconStyle} />
            </FeaturedIcon>
            <FeatureHighlight className={highlightClass}>
              {content.features.series_d_funding.value}
            </FeatureHighlight>
            <FeaturedTitle>
              {content.features.series_d_funding.titleLine1}
              <br /> {content.features.series_d_funding.titleLine2}
            </FeaturedTitle>
            <FeaturedDescription>
              {content.features.series_d_funding.description}
            </FeaturedDescription>
          </Featured>
        </FeatureGroup>
      </Container>
    </FeaturedSection>
  );
};
